export default {
	properties: [
		{
			text: 'Nombre',
			key: 'nombre',
			type: 'text',
			value: '',
		},
	],
	singular_model_name_spanish: 'Resolucion siniestro',
	plural_model_name_spanish: 'Resolucion siniestro',
	create_model_name_spanish: 'Nueva',
	text_delete: 'la',
}